export default {
  allNoteTypes: [],
}
